import { jsx as t } from "react/jsx-runtime";
import { forwardRef as c, useRef as f, useEffect as m } from "react";
import n from "./styles.module.less.js";
import d from "react-phone-number-input";
import "react-phone-number-input/style.css";
const g = c(
  (e, a) => {
    var o;
    const { value: s, disabled: u, onChange: l, className: p, error: i } = e, r = f(null);
    return m(() => {
      r.current && r.current.focus();
    }, []), /* @__PURE__ */ t(
      "div",
      {
        ref: a,
        ...e.props,
        className: `${n.phoneInput} ${(o = e.props) == null ? void 0 : o.className} ${i ? n.error : ""}`,
        children: /* @__PURE__ */ t(
          d,
          {
            ref: r,
            onChange: l,
            value: s,
            defaultCountry: navigator.language.includes("-") ? navigator.language.split("-")[1].toLocaleUpperCase() : "AU",
            disabled: u,
            className: p
          }
        )
      }
    );
  }
);
g.displayName = "PhoneInput";
export {
  g as PhoneInput
};
